var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998106 1.99981C0.997649 1.76615 1.07902 1.53972 1.22811 1.35981C1.31205 1.25855 1.41516 1.17485 1.5315 1.11349C1.64785 1.05214 1.77516 1.01435 1.90613 1.00227C2.03711 0.990194 2.16918 1.00408 2.29479 1.04312C2.42039 1.08216 2.53706 1.1456 2.63811 1.22981L7.99811 5.70981L13.3681 1.38981C13.4704 1.30674 13.5881 1.24471 13.7144 1.20728C13.8408 1.16985 13.9733 1.15775 14.1043 1.17169C14.2353 1.18563 14.3623 1.22533 14.4779 1.2885C14.5936 1.35168 14.6956 1.43708 14.7781 1.53981C14.8691 1.64327 14.9378 1.76444 14.9798 1.8957C15.0218 2.02696 15.0362 2.16549 15.0221 2.30258C15.008 2.43967 14.9658 2.57238 14.898 2.69236C14.8301 2.81234 14.7383 2.91701 14.6281 2.99981L8.62811 7.82981C8.44917 7.97689 8.22473 8.05729 7.99311 8.05729C7.76148 8.05729 7.53704 7.97689 7.35811 7.82981L1.35811 2.82981C1.23709 2.72949 1.14143 2.60206 1.07888 2.45785C1.01633 2.31364 0.988655 2.15671 0.998106 1.99981Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarr);
export default __webpack_public_path__ + "static/media/downarr.e3d703d275c2beb0f0f9c54da403695c.svg";
export { ForwardRef as ReactComponent };